<template>
    <div id="pad-wrapper" class="animation-duration">
        <div class="row head">
            <div class="col-md-9">
                <h4>Список сайтов</h4>
            </div>
            <div class="col-md-3">
                <el-button class="pull-right" type="success" @click="$router.push({name:'AddSite'})">Добавить сайт</el-button>
            </div>
        </div>

        <div class="row">
            <el-table
                    :data="sites"
                    :default-sort = "{prop: 'id', order: 'ascending'}"
                    style="width: 100%">
                <el-table-column
                        prop="id"
                        label="ID"
                        sortable
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="on"
                        label="Статус"
                        sortable
                        width="90">
                        <template slot-scope="scope">
                            <el-switch
                                    v-model="scope.row.on"
                                    active-color="#13ce66"
                                    @change="changeSiteStatus(scope.$index, scope.row)"
                                    >
                            </el-switch>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="Наименование"
                        >
                </el-table-column>
                <el-table-column
                        prop="domain"
                        label="Домен"
                        sortable
                        >
                </el-table-column>
                <el-table-column
                        v-if="IS_ADMIN"
                        prop="id"
                        label="Поставщики">
                    <template slot-scope="scope">
                        <div style="padding: 5px 0px;">
                            <span
                                    v-for="provider in JSON.parse(scope.row.providers)"
                                    :key="provider.id"
                                    class="myspanprovider ml-2"
                                    small>
                            {{provider.title}}
                            </span>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column
                        prop="geo"
                        label="Гео-фильтр"
                        sortable
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.geo">Включен</span>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="Управление"
                        width="120">
                    <template slot-scope="scope">
                        <el-button type="warning" plain icon="el-icon-edit" circle size="mini" @click="$router.push({path:'/sites/edit/'+scope.row.id})"></el-button>
                        <el-button type="danger" plain icon="el-icon-delete" circle size="mini" @click="siteDelete(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex'

    export default {
        computed: {
            ...mapGetters('Sites', {
                sites: 'GET_SITES'
            }),
            ...mapGetters('Users', {
                IS_ADMIN: 'IS_ADMIN'
            }),
        },
        mounted() {
            this.loadSites()
        },
        methods: {
            ...mapActions('Sites', {
                loadSites: 'loadSites',
                editSite: 'editSite',
                deleteSite: 'deleteSite'
            }),
            changeSiteStatus(a,b) {
                this.editSite({
                    id: b.id,
                    on: b.on
                })
            },
            siteDelete(site) {
                this.$confirm('Вы действительно желаете удалить сайт '+site.title+'?', 'Внимание', {
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    this.deleteSite(site)
                        .then(() => {
                            this.$message({
                                type: 'success',
                                message: 'Сайт удален'
                            })
                            this.loadSites()
                        })

                })
            }
        }
    }
</script>

<style scoped>
.myspanprovider {
    background: #eee;
    border: 1px solid #bbb;
    border-radius: 5px;
    padding: 0px 5px;
    display: inline-table;
}
</style>